import client from '@/clients/customer/api-client';
import { withCacheTTL } from '../common/with-cache-ttl';

export const getPages = (headers: any) => client.get('/pages', { headers });
export const getCachedPages = withCacheTTL(getPages, '/pages');
export const getPageBySlug = (slug: string, headers: any) =>
  client.get(`/pages/${slug}`, { headers });
